// services/history.js
import axiosInstance from './axiosInstance';

const HISTORY_API_URL = '/history';

const historyService = {
  async getHistory(idempresa, idproduct, search = '', page = 1, limit = 10, tables = []) {
    try {
      const searchParam = search ? `&search=${encodeURIComponent(search)}` : '';
      const tablesParam = tables.length > 0 ? `&tables=${tables.join(',')}` : '';
      const response = await axiosInstance.get(`${HISTORY_API_URL}/get.php?idempresa=${idempresa}&idproduct=${idproduct}&page=${page}&limit=${limit}${searchParam}${tablesParam}`);
      return response.data !== "NOK" ? response.data : [];
    } catch (error) {
      console.error('Erro ao obter histórico:', error);
      return [];
    }
  }
};

export default historyService;
